exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".loading___3EWAa {\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n  padding: 50px;\n  justify-content: center; }\n  .loading___3EWAa.inline___5dfqt {\n    padding: 0; }\n", "", {"version":3,"sources":["/Users/fdev/code/factorial/factorial-components/src/components/Loading/src/components/Loading/index.scss"],"names":[],"mappings":"AAGA;EACE,eAAc;EACd,cAAa;EACb,oBAAmB;EACnB,cAAa;EACb,wBAAuB,EAKxB;EAVD;IAQI,WAAU,EACX","file":"index.scss","sourcesContent":["@import 'variables/colors';\n@import 'variables/fonts';\n\n.loading {\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n  padding: 50px;\n  justify-content: center;\n\n  &.inline {\n    padding: 0;\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"loading": "loading___3EWAa",
	"inline": "inline___5dfqt"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":true,"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./~/sass-loader/lib/loader.js?{"includePaths":["/Users/fdev/code/factorial/factorial-components/styles"],"sourceMap":true}!./~/postcss-loader/lib?{"path":"/Users/fdev/code/factorial/factorial-components/webpack/postcss.config.js"}!./src/components/Loading/index.scss
// module id = 98
// module chunks = 0